/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import React from 'react';
import { RouteComponentProps, matchPath } from 'react-router-dom';
import { PageNotFound } from 'shared/components';
import { Container } from './Styles';
import CustomerCreate from './CustomerCreate';
import CustomerEdit from './CustomerEdit';

const CompanyDetail: React.FC<RouteComponentProps> = (props) => {
  const { location } = props;

  let content = <PageNotFound />;

  const matchPage = (path: string) => {
    return !!matchPath(location.pathname, path);
  };

  if (matchPage(`/setting/customer/create`)) {
    content = <CustomerCreate />;
  } else if (matchPage(`/setting/customer/edit`)) {
    content = <CustomerEdit />;
  }

  return <Container>{content}</Container>;
};

export default CompanyDetail;
